import React from 'react';
import NumberFormat from 'react-number-format';

export default class StartingAmountInput extends React.Component {

    rejectValue(values) {
        return !(values.value.length > 1 && values.value[0] === '0');
    }

    onChange(e) {
        const event = { ...e };
        event.target.value = event.target.value.replace(/[^0-9\.]/g, '');
        this.props.onChange(event);
    }

    render() {
        const { isIsraeli, ...passProps } = this.props;
        return <div className="dollar-input">
            {isIsraeli ? <i className="material-icons shekel-icon">₪</i> : <i className="material-icons">attach_money</i>}
            <NumberFormat {...passProps} thousandSeparator={true} decimalScale={2}
                          onChange={this.onChange.bind(this)} isAllowed={this.rejectValue.bind(this)} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundsCommon/StartingAmountInput.jsx